import {
  validateAFM,
  validateEmail,
  validatePhoneNumber,
  validGEMI,
} from 'utils';
import { Tooltip } from 'components';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import { companyLegalTypeList } from '././../optionsList';

export const formFields111 = [
  {
    label: 'Αρ. Γ.Ε.ΜΗ.',
    id: 'abiGcrCode',
    type: 'text',
    name: 'abiGcrCode',
    className: 'like-text',
    size: 'large',
    simple: true,
    placeholder: 'Εισάγετε Αριθμό Γ.Ε.ΜΗ.',
    maxLength: 12,
    span: 24,
    asterisk: true,
    rules: [
      ({ getFieldValue }) => ({
        validator(value) {
          const abiGcrCode = getFieldValue('abiGcrCode');
          // Is this needed?
          // const companyLegalType = getFieldValue('companyLegalType');
          // const isAtomiki = companyLegalType === 'Ατομική' ? true : false;
          if (!validGEMI(abiGcrCode)) {
            return Promise.reject([
              'Τα ψηφία του Αρ. Γ.Ε.ΜΗ. πρέπει να είναι 12 αριθμοί',
            ]);
          }
          return Promise.resolve();
        },
      }),
    ],
  },
  {
    label: 'Επωνυμία Επιχείρησης',
    id: 'companyName',
    type: 'text',
    name: 'companyName',
    size: 'large',
    placeholder: 'Εισάγετε Επωνυμία Επιχείρησης',
    span: 12,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    disabled: true,
    asterisk: true,
  },
  {
    label: 'Α.Φ.Μ. Επιχείρησης',
    id: 'legalVat',
    type: 'text',
    name: 'legalVat',
    size: 'large',
    maxLength: 10,
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return value ? validateAFM(value.toString()) : Promise.resolve();
        },
      }),
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Νομική Μορφή',
    title: 'Νομική Μορφή',
    type: 'select',
    id: 'companyLegalType',
    className: 'like-text',
    name: 'companyLegalType',
    size: 'large',
    options: companyLegalTypeList,
    placeholder: 'Επιλέξτε Νομική Μορφή',
    span: 24,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ',
    id: 'businessSize',
    type: 'businessSize',
    name: 'businessSize',
    span: 24,
    bold: true,
    defaultValue: '',
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];

export const formFields112 = owner =>
  [
    {
      label: 'Δήμος',
      id: 'abiDistrict',
      type: 'text',
      className: 'like-text',
      name: 'abiDistrict',
      size: 'large',
      placeholder: 'Εισάγετε Δήμο',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 50, message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      ],
      asterisk: true,
      disabled: true,
    },
    {
      label: 'Οδός - Αριθμός',
      id: 'buildStreet',
      type: 'text',
      name: 'buildStreet',
      size: 'large',
      placeholder: 'Εισάγετε Οδό - Αριθμό.',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 50, message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      ],
      asterisk: true,
      disabled: true,
    },
    {
      label: 'Τ.Κ.',
      id: 'buildTk',
      type: 'text',
      className: 'like-text',
      simple: true,
      name: 'buildTk',
      size: 'large',
      placeholder: 'Εισάγετε Τ.Κ.',
      span: 12,
      maxLength: 5,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        () => ({
          validator(_, value) {
            return value && String(value).length !== 5
              ? Promise.reject('Το πεδίο πρέπει να έχει ακριβώς 5 ψηφία')
              : Promise.resolve();
          },
        }),
      ],
      asterisk: true,
      disabled: true,
    },
    {
      label: 'Τηλέφωνο Επικοινωνίας',
      id: 'legalPhoneMobile',
      type: 'text',
      name: 'legalPhoneMobile',
      simple: true,
      size: 'large',
      placeholder: 'Εισάγετε 69xxxxxxxx',
      span: 24,
      maxLength: 10,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        () => ({
          validator(_, value) {
            return validatePhoneNumber(value.toString(), true);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'E-mail Επικοινωνίας',
      id: 'legalEmail',
      type: 'text',
      name: 'legalEmail',
      size: 'large',
      placeholder: 'Εισάγετε E-mail Επικοινωνίας',
      span: 24,
      maxLength: 50,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        {
          validator(_, value) {
            return validateEmail(_, value);
          },
        },
      ],
      asterisk: true,
    },
  ].filter(item => !item?.hidden);
